import { Table, TablePagination, TablePropertyFiltering, TableSelection } from 'AWS-UI-Components-React';
import React from 'react';
import { ApiInvocationStatus } from '../../constants/constants';
import { displayStatusBadge, getFilteringOptions, simulationFilteringFunction } from './simulator_utils';

export class SimulationsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSimulation: props.selected,
      onSelectionChange: props.onSelectionChange,
      simulations: props.simulations,
      filteringTokens: props.filteringTokens || [],
    };
    this.pageSize = 9;
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.filteringTokens !== this.props.filteringTokens) {
      this.setState({ filteringTokens: this.props.filteringTokens || [] });
    }
  };

  columnDefinitions = () => {
    return [
      {
        id: 'name',
        header: 'Simulation',
        cell: (item) => (
          <span>
            {item.name} {displayStatusBadge(item)}
          </span>
        ),
      },
    ];
  };

  getFeatures = () => {
    let features = ['selection', 'propertyFiltering'];
    const { simulations } = this.state;
    if (simulations && simulations.length > this.pageSize) {
      features.push('pagination');
    }
    return features;
  };

  onSelection = (event) => {
    const selected = event.detail.selectedItems[0];
    this.setState({ selectedSimulation: selected });
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(selected);
    }
  };

  isItemDisabled = () => {
    return this.props.status === ApiInvocationStatus.IN_PROGRESS;
  };

  onPropertyFilteringChange = (event) => {
    const filteringTokens = event.detail.tokens;
    this.setState({ filteringTokens });
    if (this.props.onFilteringTokensChange) {
      this.props.onFilteringTokensChange(filteringTokens);
    }
  };

  render() {
    const { simulations, selectedSimulation, filteringTokens } = this.state;
    return (
      <Table
        loadingText="Loading simulations"
        loading={!simulations}
        columnDefinitions={this.columnDefinitions()}
        items={simulations || []}
        features={this.getFeatures()}
        stickyHeader={true}
        empty={
          <div className="awsui-util-t-c">
            <div className="awsui-util-pt-s awsui-util-mb-xs">
              <b>No simulations</b>
            </div>
          </div>
        }
      >
        <TableSelection
          selectionType={'single'}
          keepSelection={true}
          selectedItems={selectedSimulation ? [selectedSimulation] : []}
          onSelectionChange={this.onSelection}
          isItemDisabled={this.isItemDisabled}
        />
        {simulations && simulations.length > this.pageSize && <TablePagination pageSize={this.pageSize} />}
        <TablePropertyFiltering
          filteringOptions={getFilteringOptions(simulations)}
          filteringFunction={simulationFilteringFunction}
          tokens={filteringTokens}
          onPropertyFilteringChange={this.onPropertyFilteringChange}
          groupValuesText="Values"
          groupPropertiesText="Properties"
          operationAndText="and"
          operationNotAndText="and not"
          operationOrText="or"
          operationNotOrText="or not"
          clearFiltersText="Clear filter"
          placeholder="Filter resources by property or value"
          allowFreeTextFiltering={true}
        />
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulations_list.jsx